const OKX = () => (
    <svg
        width='30'
        height='46'
        viewBox='0 0 60 46'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='okx'
    >
        <g clip-path='url(#clip0_0_3)'>
            <path
                d='M17.4808 0H0.39729C0.291929 0 0.19094 0.10767 0.116393 0.29948C0.041845 0.491034 0 0.751124 0 1.02222V44.9778C0 45.2489 0.041845 45.509 0.116393 45.7005C0.19094 45.8923 0.291929 46 0.39729 46H17.4808C17.5862 46 17.6873 45.8923 17.7618 45.7005C17.8363 45.509 17.8781 45.2489 17.8781 44.9778V1.02222C17.8781 0.751124 17.8363 0.491034 17.7618 0.29948C17.6873 0.10767 17.5862 0 17.4808 0ZM11.9188 29.6445C11.9188 29.9156 11.8769 30.1755 11.8024 30.3673C11.7279 30.5591 11.6268 30.6668 11.5215 30.6668H6.35672C6.25136 30.6668 6.15027 30.5591 6.07572 30.3673C6.00128 30.1755 5.95943 29.9156 5.95943 29.6445V16.3555C5.95943 16.0844 6.00128 15.8245 6.07572 15.6327C6.15027 15.4409 6.25136 15.3332 6.35672 15.3332H11.5215C11.6268 15.3332 11.7279 15.4409 11.8024 15.6327C11.8769 15.8245 11.9188 16.0844 11.9188 16.3555V29.6445Z'
                fill='white'
            />
            <path
                d='M53.5076 15.7749H48.3431C48.1237 15.7749 47.9458 16.2061 47.9458 16.7382V29.2618C47.9458 29.7937 48.1237 30.2251 48.3431 30.2251H53.5076C53.7273 30.2251 53.9052 29.7937 53.9052 29.2618V16.7382C53.9052 16.2061 53.7273 15.7749 53.5076 15.7749Z'
                fill='white'
            />
            <path
                d='M47.5485 0H42.3837C42.1643 0 41.9865 0.470705 41.9865 1.05166V14.7232C41.9865 15.3042 42.1643 15.7749 42.3837 15.7749H47.5485C47.768 15.7749 47.9458 15.3042 47.9458 14.7232V1.05166C47.9458 0.470705 47.768 0 47.5485 0Z'
                fill='white'
            />
            <path
                d='M59.5934 0H54.3117C54.0871 0 53.9052 0.470705 53.9052 1.05166V14.7232C53.9052 15.3042 54.0871 15.7749 54.3117 15.7749H59.5934C59.818 15.7749 60 15.3042 60 14.7232V1.05166C60 0.470705 59.818 0 59.5934 0Z'
                fill='white'
            />
            <path
                d='M47.5485 30.2251H42.3837C42.1643 30.2251 41.9865 30.6958 41.9865 31.2768V44.9483C41.9865 45.5293 42.1643 46 42.3837 46H47.5485C47.768 46 47.9458 45.5293 47.9458 44.9483V31.2768C47.9458 30.6958 47.768 30.2251 47.5485 30.2251Z'
                fill='white'
            />
            <path
                d='M59.5934 30.2251H54.3117C54.0871 30.2251 53.9052 30.6958 53.9052 31.2768V44.9483C53.9052 45.5293 54.0871 46 54.3117 46H59.5934C59.818 46 60 45.5293 60 44.9483V31.2768C60 30.6958 59.818 30.2251 59.5934 30.2251Z'
                fill='white'
            />
            <path
                d='M38.6005 0H33.3183C33.0939 0 32.912 0.470705 32.912 1.05166V14.7232C32.912 15.3042 33.0939 15.7749 33.3183 15.7749H38.6005C38.8248 15.7749 39.0068 15.3042 39.0068 14.7232V1.05166C39.0068 0.470705 38.8248 0 38.6005 0Z'
                fill='white'
            />
            <path
                d='M38.6005 30.2251H33.3183C33.0939 30.2251 32.912 30.6958 32.912 31.2768V44.9483C32.912 45.5293 33.0939 46 33.3183 46H38.6005C38.8248 46 39.0068 45.5293 39.0068 44.9483V31.2768C39.0068 30.6958 38.8248 30.2251 38.6005 30.2251Z'
                fill='white'
            />
            <path
                d='M32.912 16.3521C32.912 16.0809 32.8702 15.8209 32.7957 15.629C32.7212 15.4374 32.6201 15.3294 32.5147 15.3294H26.9527V1.02273C26.9527 0.7515 26.9109 0.491279 26.8363 0.29963C26.7619 0.107724 26.6608 0 26.5554 0H21.3907C21.2852 0 21.1842 0.107724 21.1097 0.29963C21.0352 0.491279 20.9933 0.7515 20.9933 1.02273V44.9773C20.9933 45.2485 21.0352 45.5087 21.1097 45.7006C21.1842 45.8923 21.2852 46 21.3907 46H26.5554C26.6608 46 26.7619 45.8923 26.8363 45.7006C26.9109 45.5087 26.9527 45.2485 26.9527 44.9773V30.6706H32.5147C32.6201 30.6706 32.7212 30.5629 32.7957 30.371C32.8702 30.1791 32.912 29.9191 32.912 29.6479V16.3521Z'
                fill='white'
            />
        </g>
        <defs>
            <clipPath id='clip0_0_3'>
                <rect width='60' height='46' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export default OKX;
